// One list of tenders for the sale forms, the money feed and the reports.
// Square left the picker on 2026-09-08 (a private-lesson studio does not run
// Square as a tender; Stefan, call 3, 1:22:40) but keeps a label so old rows
// still read. Venmo and Gift certificate joined the same day.
export const PAY_METHODS = ["card", "cash", "zelle", "venmo", "check", "gift_certificate", "other"];

export const TENDER_LABELS = {
  card: "Card",
  stripe: "Card (online)",
  bank: "Bank (online)",
  cash: "Cash",
  zelle: "Zelle",
  venmo: "Venmo",
  check: "Check",
  gift_certificate: "Gift certificate",
  square: "Square",
  credit: "Account credit",
  other: "Other",
};

export const tenderLabel = (method) =>
  TENDER_LABELS[method] || (method ? method[0].toUpperCase() + method.slice(1) : "");

// Once a studio can charge cards through Swyvel, "Card" in a picker means
// two things: we charged it, or they paid by card somewhere else and the
// desk is writing it down. One word for both is how a sale got marked paid
// with no charge behind it (Stefan, call 7, 19:08). There, the written-down
// kind says so.
export const recordedLabel = (method, chargesHere = false) =>
  method === "card" && chargesHere ? "Card, taken elsewhere" : tenderLabel(method);

// "Visa •••• 4242", for the card a contact keeps on file.
export const savedCardName = (person) => {
  if (!person || !person.card_last4) return "card";
  const brand = person.card_brand ? person.card_brand[0].toUpperCase() + person.card_brand.slice(1) : "Card";
  return `${brand} •••• ${person.card_last4}`;
};

// Every card a contact keeps, main first, with the tender each one is in a
// payment picker. A backup is only ever charged when the desk picks it.
export const savedCards = (person) => {
  if (!person) return [];
  const kept = Array.isArray(person.saved_cards) && person.saved_cards.length
    ? person.saved_cards
    : person.card_last4 ? [{ slot: "main", name: savedCardName(person) }] : [];
  return kept.map((card) => ({
    ...card,
    method: card.slot === "backup" ? "card_on_file_backup" : "card_on_file",
    label: card.slot === "backup" ? `${card.name} (backup)` : card.name,
  }));
};

// A payment as the record prints it. A card Swyvel charged carries its own
// words ("Charged Visa •••• 4242"); the rest are tenders.
export const paymentLabel = (payment, chargesHere = false) => {
  if (payment && payment.charged && /^Charged /.test(payment.note || "")) return payment.note;
  return recordedLabel(payment && payment.method, chargesHere);
};
